import { GzEnumerationIconWebComponent } from './component/GzEnumerationIconWebComponent';

export { GzEnumerationIconWebComponent };
